<template>
  <div class="home py-5">
    <div v-if="dataLoaded" class="sheet-container">
      <AveineOrderSheet :APIbaseURL="APIbaseURL" :order="order" :ambassador="ambassador" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineOrderSheet } from 'aveine-sale';
import { Order, Ambassador } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      order: {},
      ambassador: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Read',
  components: {
    AveineOrderSheet
  },
  async created() {
    try {
      await Order.api().get(`orders/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
            'order-products.product,customer,' +
            'shop,current-subtotal-price-set.shop-money,' +
            'subtotal-price-set.shop-money,' +
            'total-discounts-set.shop-money,' +
            'total-price-set.shop-money,' + 
            'shipping-line.original-price-set.shop-money,'+
            'total-tax-set.shop-money,' +
            'fulfillments.tracking-info,' +
            'aveine-refunds,' +
            'billing-address,shipping-address'
          }
        }
      );
      this.order = await Order.query().whereId(`gid://shopify/Order/${this.$route.params.id}`).withAllRecursive().first();

      if (this.order.discount_code) {
        const ambassadorReq = await Ambassador.api().get(`ambassadors?lang=${this.$i18n.locale}`, {
          params: {
            "filter[promotion-code]": this.order.discount_code,
          }
        })
        if (ambassadorReq.entities.ambassadors && ambassadorReq.entities.ambassadors[0]) {
          this.ambassador = await Ambassador.query().whereId(ambassadorReq.entities.ambassadors[0].id).withAllRecursive().first();
        }
      }
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
